import { render, staticRenderFns } from "./wlpa.vue?vue&type=template&id=4adf27b8"
import script from "./wlpa.vue?vue&type=script&lang=js"
export * from "./wlpa.vue?vue&type=script&lang=js"
import style0 from "./wlpa.vue?vue&type=style&index=0&id=4adf27b8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports